import React from "react";

/**
 * A small marker saying this is a preview and what is in it.
 *
 * The nav on this page goes to Buy, Sell, Let, Guides, About and Contact,
 * and only the home page is built in the new theme, so every one of those
 * links lands on the old design. Without a word of explanation that reads as
 * the preview being broken rather than unfinished.
 *
 * Deliberately a floating pill rather than a bar across the top: a bar would
 * push the sticky header down and change the very layout it is there to let
 * somebody judge.
 */
/**
 * `built` names what is in the theme so far. Defaulted here rather than
 * passed from six pages, which is six places to forget when a seventh
 * lands.
 */
export default function PreviewBadge({ built = "The public pages" }) {
  return (
    <div
      data-testid="estate-preview-badge"
      style={{
        position: "fixed", left: 16, bottom: 16, zIndex: 60,
        display: "flex", alignItems: "center", gap: 10,
        padding: "8px 14px", borderRadius: 999,
        background: "hsl(var(--primary))", color: "hsl(var(--background))",
        font: "600 11px/1.2 'Manrope', system-ui, sans-serif",
        letterSpacing: ".1em", textTransform: "uppercase",
        boxShadow: "0 10px 30px -12px rgba(0,0,0,.6)",
      }}
    >
      <span style={{ color: "hsl(var(--accent))" }}>Preview</span>
      <span style={{ opacity: .75, textTransform: "none", letterSpacing: 0, fontWeight: 500 }}>
        {built} are in the new design. Anything else is the live site.
      </span>
      <a href="?theme=off" style={{ textDecoration: "underline", opacity: .75 }}>Exit</a>
    </div>
  );
}
